import { MAX_DESTINATIONS } from '@repo/api-contracts';
import { Plus } from 'lucide-react';
import { type ReactElement, useId } from 'react';
import { DESTINATION_LIMIT_MESSAGE } from '@/entities/quote';
import { Button } from '@/shared/ui';

export interface DestinationAddButtonProps {
  /** 지금 카드 수 — MAX_DESTINATIONS 이면 잠근다. */
  readonly count: number;
  readonly onAdd: () => void;
  readonly disabled?: boolean;
}

/** [배송지 추가] — 10곳이면 잠그고 한도 안내를 버튼 설명(aria-describedby)으로 단다(spec §6-1). */
export const DestinationAddButton = ({
  count,
  onAdd,
  disabled = false,
}: DestinationAddButtonProps): ReactElement => {
  const limitId = useId();
  const full = count >= MAX_DESTINATIONS;

  return (
    <div className="flex flex-col gap-2">
      <Button
        type="button"
        variant="outline"
        className="h-11 w-full border-dashed border-foreground/30"
        disabled={disabled || full}
        aria-describedby={full ? limitId : undefined}
        onClick={onAdd}
      >
        <Plus aria-hidden className="size-4" strokeWidth={1.5} />
        배송지 추가
      </Button>
      {full ? (
        <p id={limitId} className="text-xs text-muted-foreground">
          {DESTINATION_LIMIT_MESSAGE}
        </p>
      ) : null}
    </div>
  );
};
